export default __webpack_public_path__ + "static/media/pro-elevate-bpn-banner-2.5c724822.jpg";